<template>
    <div class="page-header signup-page section-image">
        <div class="page-header-image"
             style="background-image: url('img/bg3.jpg')">
        </div>
        <div class="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 ml-auto mr-auto">
                        <div class="info info-horizontal">
                            <div class="icon icon-primary">
                                <i class="now-ui-icons media-2_sound-wave"></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">Live Streaming</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis erod.
                                </p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary">
                                <i class="now-ui-icons media-1_button-play"></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">VOD</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis erod.
                                </p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-info">
                                <i class="now-ui-icons objects_globe"></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">6 Languages</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis erod.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mr-auto">
                        <div class="card card-signup">
                            <div class="card-body">
                                <h4 class="card-title text-center">Signup</h4>
                                <div class="social text-center">
                                    <n-button round icon class="btn-twitter">
                                        <i class="fab fa-twitter"></i>
                                    </n-button>
                                    <n-button round icon class="btn-facebook">
                                        <i class="fab fa-facebook"> </i>
                                    </n-button>
                                    <h5 class="card-description"> or be classical </h5>
                                </div>
                                <fg-input addon-left-icon="now-ui-icons text_caps-small"
                                          v-model="form.name"
                                          placeholder="Your Name...">
                                </fg-input>

                                <fg-input addon-left-icon="now-ui-icons ui-1_email-85"
                                        v-model="form.email"
                                        placeholder="Your Email...">
                                </fg-input>

                                <fg-input addon-left-icon="now-ui-icons objects_key-25"
                                    placeholder="Password..."
                                    v-model="form.password"
                                    :rules="passwordRules"
                                    required
                                    type="password">
                                </fg-input>
 
                                <fg-input addon-left-icon="now-ui-icons objects_key-25"
                                    placeholder="Confirm Password..."
                                    v-model="form.confirm_password"
                                    :rules="passwordRules"
                                    required
                                    type="password">
                                </fg-input>

                                <n-checkbox v-model="form.agree">
                                    I agree to the terms and
                                    <a href="#something">conditions</a>.
                                </n-checkbox>

                                <div class="card-footer text-center">
                                    <n-button @click.native="login" type="primary" round size="lg">Submit</n-button>
                                </div>

                                <div class="row">
                                    <div class="col-sm">
                                    <router-link to="/login">
                                        <a class="nav-link" style="font-size:12px">
                                        Login
                                        </a>
                                    </router-link>
                                    </div>
                                    <div class="col-sm">
                                    <router-link to="/pages/user">
                                        <a class="nav-link" style="font-size:12px">
                                        Forgot Password?
                                        </a>
                                    </router-link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main-footer></main-footer>
    </div>
</template>

<script>
  import { Card, Button, FormGroupInput, Checkbox } from '@/components';
  import MainFooter from '@/layout/MainFooter';

  export default {
    name: 'signup-page',
    bodyClass: 'signup-page',
    components: {
      Card,
      MainFooter,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
            name: null,
            email: null,
            password: null,
            confirm_password: null,
        },
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
                v => !!v || 'Password is required!!!!'
        ],
      }
    },
    methods: {
        signup() {
            User.signup(this.form)
        }
    }
  }
</script>

<style>
</style>

